import React from 'react';
import { Box, useTheme } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

const Loading = () => {
  const theme = useTheme();

  return (
    <Box
      display="flex"
      px={3}
      height={theme.spacing(6)}
      alignItems="center"
      flexGrow={1}
    >
      <Skeleton variant="circle" width={30} height={30} />
      <Box pl={1} display="flex" flexGrow={1}>
        <Skeleton variant="text" width="100%" />
      </Box>
    </Box>
  );
};

export default Loading;
